import React from 'react';
import Image from '../../image';

import ingredientsStyle from './recipe-ingredients.module.css';

type Props = {
  informations: string[];
  ingredients: string[];
  pid: string;
};

const RecipeIngredients = ({ informations, ingredients, pid }: Props) => {
  return (
    <div
      className={`recipe-sticker recipe-content recipe-${pid}-sticker ${ingredientsStyle.wrapper}`}
    >
      <h2 className={ingredientsStyle.title}>
        <Image
                alt="Ingrédients"
                className={ingredientsStyle.title}
                path={`ingredients.png`}
              />
      </h2>
      <div className={ingredientsStyle.scroll}>
        <ul className={ingredientsStyle.information}>
          <li>- pour {informations[0]} -</li>
          <li>{informations[1]}</li>
        </ul>
        <ul className={ingredientsStyle.list}>
          {ingredients.map((ingredient, index) => (
            <li key={`ingredient${index}`} dangerouslySetInnerHTML={{__html: ingredient}}/>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RecipeIngredients;
